<div class="sidebar">
  <div class="sidebar-header">
    <img src="assets/lacivert-logo.svg" alt="Lacivert" class="logo-img">
    <h2 class="panel-title">KAPTAN PANELİ</h2>
  </div>

  <div class="system-status">
    <div class="status-label">SİSTEM DURUMU</div>
    <div class="status-control">
      <span class="status-text" [ngClass]="{'open': systemStatus === 'open', 'busy': systemStatus === 'busy', 'closed': systemStatus === 'closed'}">
        {{ systemStatus === 'open' ? 'AÇIK' : (systemStatus === 'busy' ? 'MEŞGUL' : 'KAPALI') }}
      </span>
    </div>
    <div class="status-buttons">
      <button
        type="button"
        class="status-button"
        [class.active]="systemStatus === 'open'"
        (click)="onChangeStatus($event, 'open')">
        AÇIK
      </button>
      <button
        type="button"
        class="status-button"
        [class.active]="systemStatus === 'busy'"
        (click)="onChangeStatus($event, 'busy')">
        MEŞGUL
      </button>
      <button
        type="button"
        class="status-button closed"
        [class.active]="systemStatus === 'closed'"
        (click)="onChangeStatus($event, 'closed')">
        KAPALI
      </button>
    </div>
  </div>

  <nav class="sidebar-nav">
    <div class="nav-item" [class.active]="currentView === 'requests'" (click)="onNavigateToRequests()">
      <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-4M9 9v12M9 3l6 4M9 7l8-4"/>
      </svg>
      <span class="nav-text">Talepler</span>
      <span class="nav-badge" *ngIf="waitingCount > 0">{{ waitingCount }}</span>
    </div>
    <div class="nav-item" [class.active]="currentView === 'history'" (click)="onNavigateToHistory()">
      <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8M3 21V15m0-6V3m18 12v6m0-6V9"/>
      </svg>
      <span class="nav-text">Geçmiş</span>
    </div>
  </nav>

  <div class="sidebar-footer">
    <div class="user-profile" (click)="navigateToProfile()">
      <div class="user-avatar" [style.background-image]="getProfilePictureUrl()"></div>
      <div class="user-info">
        <div class="user-name">{{ currentUser?.name || 'Kaptan' }}</div>
        <div class="user-role">Lacivert 1</div>
      </div>
    </div>
    <button class="logout-btn" (click)="logout()" title="Çıkış Yap">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/>
      </svg>
    </button>
  </div>
</div>

